import {
    COMPETITIONS_POST_FAILURE,
    COMPETITIONS_POST_REQUEST,
    COMPETITIONS_POST_SUCCESS,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export const competitionPostReducer = (state = initialState, action) => {
    const {type, competition} = action;

    switch (type) {
        case COMPETITIONS_POST_SUCCESS: {return {
            ...initialState,
            competition,
        }}

        case COMPETITIONS_POST_REQUEST: {return {
            ...initialState,
            posting: true,
        }}

        case COMPETITIONS_POST_FAILURE: {return {
            ...initialState,
            posting: false,
            hasErrors: true,
        }}

        default: {return state}
    }
};
